module.exports = __webpack_public_path__ + "static/media/italic_text_logo.d2519687.png";